import React from 'react';
import { useTheme } from '../../../styles/ThemeProvider';

export const EmptyState = ({ title = 'Bu tarih aralığında veri yok', description, action }) => {
  const { theme } = useTheme();
  return (
    <div style={{ textAlign: 'center', padding: theme.space.xxl, color: theme.color.textSoft }}>
      <div style={{ fontSize: theme.font.size.lg, fontWeight: theme.font.weight.semibold, marginBottom: theme.space.sm, color: theme.color.text }}>{title}</div>
      {description && <div style={{ fontSize: theme.font.size.sm, marginBottom: theme.space.base }}>{description}</div>}
      {action}
    </div>
  );
};
